module.exports = __webpack_public_path__ + "img/needle-ab.4b81da04.png";